<ng-container *ngIf="currencies">
  <div class="d-flex align-items-center justify-content-between mb-2">
    <h6 class="mb-0 small text-uppercase fw-semibold text-secondary">Currency Exchange</h6>
    <button type="button" class="btn btn-sm btn-link text-decoration-none p-0" (click)="updateExchangeRates($event)">
      <i class="fas fa-arrows-rotate me-1"></i>Use Today's Rates
    </button>
  </div>

  <div class="d-flex align-items-center flex-wrap gap-2 mb-3 small">
    <span *ngIf="conversionFactor.isExchangeRateFixed" class="badge rounded-pill text-bg-warning fw-normal">
      <i class="fas fa-lock me-1"></i>Fixed at {{conversionFactor.exchangeRateDate.toDate() | date: 'yyyy-MM-dd'}}
    </span>
    <a [routerLink]="['/tenders', tender.id, 'analytics-settings']" class="ms-auto text-decoration-none">
      Tender Currency Settings
      <i class="fas fa-arrow-up-right-from-square ms-1 small"></i>
    </a>
  </div>

  <div class="d-flex flex-column gap-2">
    <div class="input-group input-group-sm" *ngFor="let item of currencies | keyvalue;">
      <span class="input-group-text rate-label">{{baseCurrency.code}} / {{item.key}}</span>
      <input class="form-control rate-input text-end font-monospace"
             type="text"
             [(ngModel)]="currencies[item.key]"
             (ngModelChange)="onCustomCurrency($event)"
             [ngModelOptions]="{standalone: true}">
    </div>
  </div>
</ng-container>
